import request from '@/request/index';
import util from '@/libs/util';

//附件列表配置
export function UploadNews(urlParms) {
    return request({
        url: '/webapi/api/sysuploadcfgs/detail/' + urlParms,
        method: 'get'
    });
}

//获取附件列表
export function UploadFileList(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/uploadfile/list/' + parmas,
        method: 'get'
    });
}

//附件删除
export function DeleteFile(urlParms) {
    return request({
        url: '/webapi/api/uploadfile/' + urlParms,
        method: 'delete'
    });
}